//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'PerioperativeHighriskCriteria',
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/PerioperativeHighriskCriteria.vue